import type { NavigateFunction } from "react-router-dom";
import type { DocumentExtractionJob } from "./documentExtractionJobs";

function reviewQuery(documentId?: string): string {
  if (!documentId) return "";
  return `?reviewDocumentId=${encodeURIComponent(documentId)}`;
}

export function buildExtractionJobUrl(job: DocumentExtractionJob, openForReview = false): string {
  const review = openForReview ? reviewQuery(job.documentId) : "";
  if (openForReview) {
    return `/document-library${review}`;
  }
  switch (job.contextType) {
    case "asset":
      return job.contextId ? `/assets/${job.contextId}${review}` : `/assets${review}`;
    case "location":
      if (job.contextId) {
        const base = `/locationmap?locationId=${encodeURIComponent(job.contextId)}`;
        return base;
      }
      return `/locationmap${review}`;
    case "library":
    default:
      return `/document-library${review}`;
  }
}

export function navigateToExtractionJob(
  job: DocumentExtractionJob,
  navigate: NavigateFunction,
  openForReview = false
): void {
  navigate(buildExtractionJobUrl(job, openForReview));
}
